import React from "react";

/**
 * Maliyet Kaynagi seçici (Ozan / Altinkaynak + Marj toggle)
 * Pure presentational component - state ve handler'lar prop ile gelir.
 */
const MaliyetKaynagiSelector = ({
  isDesktop,
  priceSource,
  applyMarj,
  clearPriceSource,
  setPriceSourceProfile,
  toggleApplyMarj,
}) => (
  <div
    style={{
      backgroundColor: '#1a2a3a',
      padding: isDesktop ? '12px 20px' : '15px 20px',
      borderRadius: '10px',
      marginBottom: '16px',
      border: '2px solid #3498db',
    }}
    data-testid="maliyet-kaynagi-section"
  >
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: isDesktop ? 'space-between' : 'center',
        flexWrap: 'wrap',
        gap: '10px',
        flexDirection: isDesktop ? 'row' : 'column',
      }}
    >
      <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px' }}>Maliyet Kaynagi</span>
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
        <button
          onClick={() => { if (priceSource === 'altinkaynak') clearPriceSource(); }}
          data-testid="source-ozan-btn"
          style={{
            padding: '8px 16px',
            fontSize: '13px',
            fontWeight: 'bold',
            borderRadius: '6px',
            cursor: priceSource !== 'altinkaynak' ? 'default' : 'pointer',
            backgroundColor: priceSource !== 'altinkaynak' ? '#DA9F54' : 'transparent',
            color: priceSource !== 'altinkaynak' ? '#000' : '#fff',
            border: '2px solid #DA9F54',
            transition: 'all 0.2s',
          }}
        >
          {priceSource !== 'altinkaynak' ? '\u2713 ' : ''}Ozan
        </button>
        <button
          onClick={() => setPriceSourceProfile('altinkaynak')}
          disabled={priceSource === 'altinkaynak'}
          data-testid="source-altinkaynak-btn"
          style={{
            padding: '8px 16px',
            fontSize: '13px',
            fontWeight: 'bold',
            borderRadius: '6px',
            cursor: priceSource === 'altinkaynak' ? 'default' : 'pointer',
            backgroundColor: priceSource === 'altinkaynak' ? '#DA9F54' : 'transparent',
            color: priceSource === 'altinkaynak' ? '#000' : '#fff',
            border: '2px solid #DA9F54',
            transition: 'all 0.2s',
          }}
        >
          {priceSource === 'altinkaynak' ? '\u2713 ' : ''}Altinkaynak
        </button>
        {priceSource === 'altinkaynak' && (
          <button
            onClick={toggleApplyMarj}
            data-testid="toggle-marj-btn"
            style={{
              padding: '8px 14px',
              fontSize: '12px',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              backgroundColor: applyMarj ? '#3498db' : '#95a5a6',
              color: '#fff',
            }}
          >
            {applyMarj ? 'Marj: AKTIF' : 'Marj: PASIF'}
          </button>
        )}
      </div>
    </div>
  </div>
);

export default MaliyetKaynagiSelector;
